/**
 * Кто открыл виджет.
 *
 * Слаг лежит в адресе, потому что один и тот же виджет обслуживает разные
 * сайты: скрипт встраивания кладёт его в ссылку кадра. Запасное значение
 * задаётся при сборке — чтобы страница виджета открывалась с каталогом
 * и без параметров в ссылке.
 *
 * Значение читается один раз при загрузке модуля: внутри одного сеанса
 * партнёр смениться не может, а зависеть от порядка импортов — может.
 *
 * Адрес читается с оглядкой на то, есть ли вообще окно. В тестах его нет,
 * и обращение к нему на верхнем уровне роняло весь файл целиком, ещё
 * до первой проверки: любой стор, привязанный к заказчику, утаскивал
 * за собой свой набор тестов.
 */
const fromUrl = (): string | null =>
  typeof window === 'undefined'
    ? null
    : new URLSearchParams(window.location.search).get('partner');

export const PARTNER_SLUG: string =
  fromUrl() ?? (import.meta.env.VITE_PARTNER as string | undefined) ?? 'demo-label';
